import audioCalls from './audio-calls';
import compliments from './compliments';
import discover from './discover';
import incognitoMode from './incognito-mode';
import instantMatch from './instant-match';
import snoozeMode from './snooze-mode';
import superswipe from './superswipe';
import travelMode from './travel-mode';

export const features = {
  audioCalls,
  compliments,
  incognitoMode,
  snoozeMode,
  superswipe,
  travelMode,
  instantMatch,
  discover,
};
